export const iconFontAwesomeWritingNewspaper = (
	<i className="fa-solid fa-newspaper"></i>
);
